import React from "react"
import { Col, Row } from "react-bootstrap"
import AccordionCard from "./AccordionCard"
import CardRow from "./CardRow"
import FormatDate from "../../../../formatters/FormatDate"
import TestCardProps from "./TestCardProps"

export default function BATAlcoholTestCard(props: TestCardProps) {
  const { data } = props
  const title = <Row>
    <Col xs={5} sm={3}>BREATH ALCOHOL TEST (BAT) COLLECTION DETAIL</Col>
    <Col xs={3} sm={5}>{data.DateCollected ? data.CollectionStatusDescription : ""}</Col>
    <Col xs={4} sm={4}>{data.DateCollected ? FormatDate(data.DateCollected) : ""}</Col>
  </Row>
  return (
    <AccordionCard eventKey="BATAlcoholTest" title={title}>
      <CardRow title="SITE" value={data.CollectorVendorName}/>
      <CardRow title="BAT TECHNICIAN" value={data.CollectedBy}/>
      <CardRow title="ARRIVED DATE" value={data.DateArrived} date/>
      <CardRow title="ARRIVED TIME" value={data.DateArrived} time/>
      <CardRow title="EXAM DATE" value={data.DateCollected} date/>
      <CardRow title="EXAM TIME" value={data.DateCollected} time/>
    </AccordionCard>
  )
}
